/**
 * General (user-scoped) notification types for the list API and SignalR payloads.
 * Job-scoped notifications remain in notifications.service.ts.
 */
export const NOTIFICATION_TYPE_COLORS = {
    urgent_action_required: "red",
    priority_action: "orange",
    normal_action: "yellow",
    confirmation: "green",
    reminder: "blue",
};
export const NOTIFICATION_TYPE_LABELS = {
    urgent_action_required: "Urgent - Action Required!",
    priority_action: "Priority Action",
    normal_action: "Normal Action",
    confirmation: "Confirmation",
    reminder: "Reminder",
};
